import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchGeneralConfig = createAsyncThunk(
  'generalConfig/fetch',
  async () => {
    const response = await api.get('/api/general-config/');
    return response.data;
  }
);

export const updateGeneralConfig = createAsyncThunk(
  'generalConfig/update',
  async (data) => {
    // Get the current config first to get the UUID
    const currentConfig = await api.get('/api/general-config/');
    const uuid = currentConfig.data.uuid;
    
    const response = await api.patch(`/api/general-config/${uuid}/`, data);
    return response.data;
  }
);

const generalConfigSlice = createSlice({
  name: 'generalConfig',
  initialState: {
    config: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch general config
      .addCase(fetchGeneralConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGeneralConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
      })
      .addCase(fetchGeneralConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Update general config
      .addCase(updateGeneralConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateGeneralConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
      })
      .addCase(updateGeneralConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default generalConfigSlice.reducer;